function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import t from "../../scripts/i18n";
import { setTranslationMissing } from "../../store/actions/app";
import "../../styling/components/common/Snackbar.css";

var Snackbar = function Snackbar(props) {
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state.app.notification;
  }),
      text = _useSelector.text,
      type = _useSelector.type,
      duration = _useSelector.duration,
      hidden = _useSelector.hidden;

  var translationMissing = useSelector(function (state) {
    return state.app.translationMissing;
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showTranslationError = _useState2[0],
      setShowTranslationError = _useState2[1];

  var closeSnackbar = function closeSnackbar() {
    dispatch({
      type: 'SET_NOTIFICATION',
      notification: {
        text: text,
        type: type,
        duration: duration,
        hidden: true
      }
    });
  };

  useEffect(function () {
    var timeOutFn = undefined;
    if (text) setTimeout(function () {
      return closeSnackbar();
    }, duration || 3000);
    return function () {
      clearTimeout(timeOutFn);
    };
  }, [text]);
  useEffect(function () {
    var timeOutFn = undefined;

    if (translationMissing.value && !translationMissing.wasShown) {
      setShowTranslationError(true);
      timeOutFn = setTimeout(function () {
        dispatch(setTranslationMissing({
          wasShown: true
        }));
        setShowTranslationError(false);
      }, 10000);
    }

    return function () {
      clearTimeout(timeOutFn);
    };
  }, [translationMissing.value]);
  return /*#__PURE__*/React.createElement("div", {
    className: "snackbar-wrapper ".concat(hidden || !showTranslationError ? 'hide' : 'show')
  }, /*#__PURE__*/React.createElement("div", {
    className: "snackbar ".concat(type, " ").concat(hidden ? 'hide' : 'show'),
    onClick: function onClick() {
      return closeSnackbar();
    }
  }, text), /*#__PURE__*/React.createElement("div", {
    className: "snackbar info ".concat(showTranslationError ? 'show' : 'hide'),
    onClick: function onClick() {
      return setShowTranslationError(false);
    }
  }, t('missing_translation_notification')));
};

export default Snackbar;